import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from "@chakra-ui/react";
import ExpertDataService from "../../services/Expert";
export const SendSyncCalendarEmailModal = ({ isOpen, onClose, email }: any) => {
  const toast = useToast();

  const sendSyncEmail = async () => {
    try {
      await ExpertDataService.sendCalendarSyncEmail(email)
        .then((res) => {
          onClose();

          toast({
            position: "top",
            title: "Sync Calendar Email Sent Successfully",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        })
        .catch((e) => {
          toast({
            position: "top",
            title: "Failed to Send Calendar Sync Email",
            description:
              e?.response?.data?.details ||
              "There was an error sending the email. Please try again later.",
            status: "error",
            duration: 1500,
            isClosable: true,
          });
        });
    } catch (error) {
      console.error("Failed to send email", error);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Email</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to send email to sync expert calendar?
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={sendSyncEmail}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
